module.exports = __webpack_public_path__ + "fonts/4fa4ea4.ttf";